import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFieldMode, getEffectiveFieldMode } from '../../auth/FieldModeContext';
import { useAuth } from '../../auth/AuthContext';

export default function AdminFieldModeToggle(): React.JSX.Element | null {
  const { user } = useAuth();
  const { fieldMode, setFieldMode } = useFieldMode();
  const navigate = useNavigate();
  const active = getEffectiveFieldMode(fieldMode);

  if (!user || user.role !== 'admin') return null;

  return (
    <section className="quote-card settings-section-card field-mode-card">
      <div className="field-mode-row">
        <div>
          <div className="quote-section-title">Field mode</div>
          <p className="settings-hint">
            Use technician navigation, jobs, and timesheet across the app. Admin Settings stays on this page — turn
            field mode off when you need the full admin workspace.
          </p>
          {active ? (
            <p className="settings-hint field-mode-active-hint">
              Field mode is <strong>on</strong>. Use the technician links in the top bar (or bottom menu on mobile) to
              open Dashboard, Job List, Time Sheet, and more.
            </p>
          ) : null}
        </div>
        <label className="field-mode-switch" aria-label="Toggle field mode">
          <input
            type="checkbox"
            checked={active}
            onChange={(e) => {
              const on = e.target.checked;
              setFieldMode(on);
              if (!on) navigate('/admin/dashboard');
            }}
          />
          <span className="field-mode-switch-ui" />
          <span className="field-mode-switch-label">{active ? 'On' : 'Off'}</span>
        </label>
      </div>
      {active ? (
        <div className="field-mode-quick-links">
          <Link to="/technician/dashboard" className="btn-primary field-mode-quick-link">
            Open technician dashboard
          </Link>
          <Link to="/technician/JobList" className="dash-btn dash-btn-ghost field-mode-quick-link">
            Job list
          </Link>
          <Link to="/technician/TimeSheet" className="dash-btn dash-btn-ghost field-mode-quick-link">
            Time sheet
          </Link>
        </div>
      ) : null}
    </section>
  );
}
